import React from 'react';
import styles from './styles.module.scss';
import magicGem from 'assets/img/magic_gem.png';
import magicGemMobile from 'assets/img/magic_gem_mobile.png';
import Button from 'src/Components/Button_V2';
import icAlameda from 'assets/img/ic_alameda_partner.png';
import icMulticoin from 'assets/img/ic_multicoin_partner.png';
import icSeedify from 'assets/img/ic_seedify_partner.png';
import icAnimoca from 'assets/img/ic_animoca_partner.png';
import icQuano6 from 'assets/img/ic_quano6_partner.png';
const CallToAction = /*#__PURE__*/React.forwardRef(({
  onButtonClick
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imgGemMobile
  }, /*#__PURE__*/React.createElement("img", {
    src: magicGemMobile
  })), /*#__PURE__*/React.createElement("img", {
    src: magicGem,
    className: styles.imgGem
  }), /*#__PURE__*/React.createElement("img", {
    src: icAlameda,
    className: styles.imgAlameda
  }), /*#__PURE__*/React.createElement("img", {
    src: icMulticoin,
    className: styles.imgMulticoin
  }), /*#__PURE__*/React.createElement("img", {
    src: icSeedify,
    className: styles.imgSeedify
  }), /*#__PURE__*/React.createElement("img", {
    src: icAnimoca,
    className: styles.imgAnimoca
  }), /*#__PURE__*/React.createElement("img", {
    src: icQuano6,
    className: styles.imgQuano6
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, /*#__PURE__*/React.createElement("span", null, "THG Staking")), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "The sooner users start staking THG, the more private tickets they can receive.")), /*#__PURE__*/React.createElement("div", {
    className: styles.paragraph
  }, /*#__PURE__*/React.createElement("span", null, "Thetan Arena partners up with reputable investment funds & incubators so that users can access to reams of investment opportunities")), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Stake Now",
    type: "warning",
    className: styles.btn,
    onClick: onButtonClick
  }))))));
});
CallToAction.displayName = 'CallToAction';
export default CallToAction;